<p>dialog-inventory-details works!</p>
